import type { ChatSender, User } from '@ztechapps/common.contract'
import type { TemplateVariables } from '../Context'
import { useTemplateResetPassword } from './useTemplateResetPassword'

export const useRequesterTemplateVariables = ({
  requester,
  sender,
}: {
  requester?: User
  sender?: ChatSender
} = {}): TemplateVariables => {
  const { resetPassword: resetPasswordMain } = useTemplateResetPassword()

  // The requester slice of the full template bag — the record providers and
  // `useBuildDefaultTemplateVariables` fill the rest, so the partial crosses as `unknown` first.
  return {
    username: requester?.profile?.email ?? sender?.profile?.email,
    profileName: requester?.profile?.name ?? sender?.profile?.name,
    resetPassword: requester?._id
      ? () => resetPasswordMain({ _id: requester._id })
      : () => Promise.reject(new Error('Link the requester to a customer before resetting a password.')),
    // Without a requester there is no one to offer a reset for — leaving it absent lets
    // `useBuildDefaultTemplateVariables` fall back to the sales order members.
    resetUsersPassword: requester?._id
      ? [{ ...requester, value: requester._id, label: requester.profile?.name }]
      : undefined,
  } as unknown as TemplateVariables
}
